import { createSelector } from 'reselect';
import { getContent } from './simpleSelectors';

/**
 * Currently unused.
 * Part of https://www.pivotaltracker.com/story/show/168674593
 */
export default createSelector([getContent], content => content);